exports = module.exports = require("../../../../../../../shared/rnclient/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.saved-diary--link--rRfIkUDs {\n  display: inline-block;\n}\n\n.saved-diary--chip--1s6zMFHD {\n  vertical-align: middle;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/saved-diary.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;CACvB;;AAED;EACE,uBAAuB;CACxB","file":"saved-diary.css","sourcesContent":["\n.link {\n  display: inline-block;\n}\n\n.chip {\n  vertical-align: middle;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"link": "saved-diary--link--rRfIkUDs",
	"chip": "saved-diary--chip--1s6zMFHD"
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!/home/deploy/gamba/shared/rnclient/node_modules/postcss-loader/lib!./src/web/components/themes/saved-diary.css
// module id = 2776
// module chunks = 4